import type { ConsentChoice } from '@lyrmo/shared';
import { createContext, useContext } from 'react';

export interface Consent {
  /** What the visitor chose about Lyrmo's own insights; null before they have. */
  readonly choice: ConsentChoice | null;
  /** Whether the choice is being asked for: before one is made, or when asked to change it. */
  readonly asking: boolean;
  readonly choose: (choice: ConsentChoice) => void;
  /** Asks for the choice again, to change it. */
  readonly ask: () => void;
}

/** No choice, and nothing asked, where no consent is provided: nothing is told apart. */
export const ConsentContext = createContext<Consent>({
  choice: null,
  asking: false,
  choose: () => undefined,
  ask: () => undefined,
});

/** The visitor's choice about Lyrmo's own insights, and how to make or change it. */
export const useConsent = (): Consent => useContext(ConsentContext);
